import { Button, Menu, MenuItem } from "@mui/material";
import React from "react";
import Chart from "react-apexcharts";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { getAnalyticsGraph } from "../../Controllers/DashBoard";


const Barchart = () => {
    const [menu, setMenu] = React.useState({ ref: null, open: false, yAxisObject: {} });
    const [graph, setGraph] = React.useState({
        xAxis: [],
        yAxis: [],
        YJobAmount: [],
        YPaymentReceived: [],
        YNonaEarning: [],
        YPayoutDone: [],
        graphTitle: "",
        type: "yearly",
        isLoad: true
    })

    const data ={
        options: {
            chart: {
                id: "basic-bar"
            },
            xaxis: {
                categories: graph.xAxis
            },
            colors: [
                "var(--nona-light-blue)",
                "var(--status-processing)"
            ]
        },
        series: [
            {
                name: "Earning (EUR)",
                data: graph.yAxis
            }
        ]
    }

    const getGraph = async (type) => {
        const res = await getAnalyticsGraph(type);
        if (res.data.status === 200) {
            setGraph({ ...graph, ...res.data.data, yAxis: res.data.data.YJobAmount, isLoad: false, graphTitle: "Total Job Amount" })
        }
       
    }

    const handleSelect = (title) => {
        if (title === "YJobAmount") {
            setGraph({ ...graph, yAxis: graph.YJobAmount, graphTitle: "Job Amount" })
        }
        else if (title === "YPaymentReceived") {
            setGraph({ ...graph, yAxis: graph.YPaymentReceived, graphTitle: "Payment Received" })
        }
        else if (title === "YNonaEarning") {
            setGraph({ ...graph, yAxis: graph.YNonaEarning, graphTitle: "Nona Earnings" })
        }
        else if (title === "YPayoutDone") {
            setGraph({ ...graph, yAxis: graph.YPayoutDone, graphTitle: "Payouts" })
        }
        setMenu({...menu,open:false})
    }

    React.useEffect(() => {
        getGraph(graph.type)
        return () => { }
    }, [])

    return (
        <div className="app">
            <div className="row">
                <div className="mixed-chart">
                    <div className="graph-header">
                        <small style={{ paddingLeft: "1rem", fontFamily: "semi-bold" }}>
                            {graph.graphTitle}
                        </small>
                        <Button
                            id="basic-button"
                            aria-controls={menu.open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={menu.open ? 'true' : undefined}
                            onClick={(e) => setMenu({ ...menu, open: true, ref: e.currentTarget })}
                            size="small"
                            sx={{ m: 0, p: 0, minWidth: "unset" }}
                        >
                            <MoreHorizIcon />
                        </Button>
                    </div>
                    {
                        !graph.isLoad &&
                        <Chart
                            options={data.options}
                            series={data.series}
                            type="bar"
                            width="100%"
                        />
                    }
                </div>

                <Menu
                    id="graph-menu"
                    anchorEl={menu.ref}
                    open={menu.open}
                    onClose={() => { setMenu({ ...menu, open: false }) }}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    <MenuItem onClick={() => { handleSelect("YJobAmount") }}>{"Jobs Amount"}</MenuItem>
                    <MenuItem onClick={() => { handleSelect("YPaymentReceived") }}>{"Payment Received"}</MenuItem>
                    <MenuItem onClick={() => { handleSelect("YNonaEarning") }}>{"Nona Earning"}</MenuItem>
                </Menu>
            </div>
        </div>
    );
}

export default Barchart